// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DnD_wrapper__39PE3"};